









































import { Vue, Component } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import progress from '@/components/progress.vue'
import { Step } from './store'
@Component({
  components: {
    'step-progress': progress
  }
})
export default class App extends Vue {
  @State('step') step !: Step
  @Action('stepTo') stepTo !: Function
  private sidebarActive = false
  mounted () {
    this.stepTo(Step.Select)
  }
  get isFinish () {
    return this.step === Step.Finish
  }
}
